<template>
  <div>
    <nav
      :class="[breadcrumbs.length > 1 ? 'sm:hidden' : '', 'flex']"
      aria-label="Back"
    >
      <LinkBase
        :href="breadcrumbs[breadcrumbs.length - 1].href"
        class="inline-flex items-center"
        color="text-gray-500"
        size="sm"
      >
        <HeroiconContainer :icon="ChevronLeftIcon" class="-ml-1 mr-1" />
        Back to {{ breadcrumbs[breadcrumbs.length - 1].title }}</LinkBase
      >
    </nav>
    <nav
      v-if="breadcrumbs.length > 1"
      class="hidden sm:flex"
      aria-label="Breadcrumb"
    >
      <ol role="list" class="flex items-center space-x-4">
        <li v-for="(breadcrumb, index) in breadcrumbs">
          <div class="flex items-center">
            <HeroiconContainer :icon="ChevronRightIcon" v-if="index > 0" />
            <LinkBase
              color="text-gray-500"
              :class="{ 'ml-4': index > 0 }"
              :href="breadcrumb.href"
              :disabled="breadcrumb.active"
            >
              {{ breadcrumb.title }}
            </LinkBase>
          </div>
        </li>
      </ol>
    </nav>
  </div>
</template>

<script setup>
import HeroiconContainer from '@/Common/Elements/HeroiconContainer.vue'
import { computed } from 'vue'
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/vue/solid'
import LinkBase from '@/Common/Text/LinkBase.vue'

const props = defineProps({
  breadcrumbs: Array,
})

const breadcrumbs = computed(() => {
  return props.breadcrumbs.map((breadcrumb) => {
    return {
      active: route(route().current(), route().params) === breadcrumb.href,
      ...breadcrumb,
    }
  })
})
</script>
